import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import WhoWeAreSection from '../components/sections/WhoWeAreSection';
import OurMissionSection from '../components/sections/OurMissionSection';
import OurApproachSection from '../components/sections/OurApproachSection';
import OurAdvantageSection from '../components/sections/OurAdvantageSection';
import OurTeamSection from '../components/sections/OurTeamSection';
import VideoSection from '../components/sections/VideoSection';
import ContactSection from '../components/sections/ContactSection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <WhoWeAreSection />
      <OurMissionSection />
      <OurApproachSection />
      <OurAdvantageSection />
      <OurTeamSection />
      <VideoSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
